import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { B as ButtCon, a as Button } from '../ButtCon/ButtCon.js';
import { useMemo, Children } from 'react';
import { f as flattenChildren } from '../../unsorted/index3.js';
import { m as merge } from '../../unsorted/index.js';
import { I as Icon } from '../Icon/Icon.js';
import { S as SmartClone } from '../SmartClone/SmartClone.js';
import { B as Body } from '../Body/Body.js';
import { isChildSubcomponent } from '../../utils/subcomponentHelpers.js';

var _excluded$2 = ["size", "variant"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ToastButtCon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "tertiary/inverse" : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx(ButtCon, _objectSpread$2(_objectSpread$2({}, props), {}, {
    size: size,
    variant: variant
  }));
}
ToastButtCon.displayName = "Toast.ButtCon";
ToastButtCon.SvgIcon = ButtCon.SvgIcon;

var _excluded$1 = ["size", "variant"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ToastButton(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "tertiary/inverse" : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return jsx(Button, _objectSpread$1(_objectSpread$1({}, props), {}, {
    size: size,
    variant: variant
  }));
}
ToastButton.displayName = "Toast.Button";
ToastButton.Icon = Button.Icon;
ToastButton.Logo = Button.Logo;

var _excluded = ["size", "sx", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ToastMessage(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var flattenedChildren = useMemo(function () {
    return flattenChildren(children);
  }, [children]);
  var mergedSx = merge({
    verticalAlign: "middle",
    c: "base.color.text.body.inverse.primary"
  }, sx);
  return jsx(Body, _objectSpread(_objectSpread({}, props), {}, {
    sx: mergedSx,
    size: size,
    children: Children.map(flattenedChildren, function (child) {
      if (isChildSubcomponent(child, Icon)) {
        return jsx(SmartClone, {
          sx: merge({
            fill: "base.color.text.body.inverse.primary",
            mr: "base.spacing.x2",
            w: "1em"
          }, child.props.sx || {}),
          children: child
        });
      }
      return child;
    })
  }));
}
ToastMessage.displayName = "Toast.Message";

export { ToastButton as T, ToastButtCon as a, ToastMessage as b };
//# sourceMappingURL=ToastMessage.js.map
